// extracted by mini-css-extract-plugin
module.exports = {"wrap":"posts-module__wrap___1xG2R"};